// extracted by mini-css-extract-plugin
export default {"primary_button":"PrimaryButton_primary_button__nOBNh","button_text":"PrimaryButton_button_text__7gxIC","button_icon":"PrimaryButton_button_icon__H2zd5"};